/* istanbul ignore file */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getCurrentSignupStepNameSelector } from 'store/user/selectors';

function ScrollToTop({ history }: any) {
  const currentSignupStep = useSelector(getCurrentSignupStepNameSelector);
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentSignupStep]);

  return null;
}

export default withRouter(ScrollToTop);
